import React, { Component } from "react";
import { List, ListItem } from "material-ui/List";
import Checkbox from "material-ui/Checkbox";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import Paper from "material-ui/Paper";

class AppEvent extends Component {
  constructor(props) {
    super(props);

    this.state = { expanded: false };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    let event = this.props.eventPassed;
    let payloadType;
    if (event.attributes)
      payloadType = (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          {event.attributes.map(attr => {
            return (
              <span style={{ fontSize: 10, color: "#aaaaaa" }}>
                {attr.name}({attr.type}){" "}
              </span>
            );
          })}
        </div>
      );
    else payloadType = "";
    return (
      <p
        style={{
          color: "#dd22dd",
          lineHeight: 1.0,
          fontSize: 12,
          padding: 2
        }}
      >
        {event.name} {"->"}
        <br />
        {payloadType}
      </p>
    );
  }
}
export default AppEvent;



// WEBPACK FOOTER //
// ./src/components/AppEvent.js